import type {
  BaseDataMessage,
  ToolCallGenericMessage,
} from '@terra/shared-dto-chat-types';
import {
  DataMessageTypeEnum,
  TerraUIMessageDataPartName,
  type TodoItem,
  type TodosMessage,
  type TerraUIMessagePart,
} from '@terra/shared-dto-chat-types';

export function finalizeStreamingChatPart(
  part: TerraUIMessagePart,
): TerraUIMessagePart {
  if (part.type === 'text' && part.state === 'streaming') {
    return {
      ...part,
      state: 'done',
    };
  }

  if (part.type === 'reasoning' && part.state === 'streaming') {
    return {
      ...part,
      state: 'done',
    };
  }

  if (part.type !== TerraUIMessageDataPartName || !part.data) {
    return part;
  }

  const dataMessage = part.data as BaseDataMessage;

  const isToolCallMessage = [
    DataMessageTypeEnum.ToolCallUpdate,
    DataMessageTypeEnum.ToolCallStart,
    DataMessageTypeEnum.ToolCallComplete,
    DataMessageTypeEnum.ToolCallError,
  ].includes(dataMessage.type as DataMessageTypeEnum);

  if (
    isToolCallMessage &&
    ((dataMessage as ToolCallGenericMessage).status === 'in-progress' ||
      (dataMessage as ToolCallGenericMessage).status === 'started')
  ) {
    const toolCall = dataMessage as ToolCallGenericMessage;

    return {
      ...part,
      data: {
        ...toolCall,
        status: 'aborted',
      } as ToolCallGenericMessage,
    };
  }

  if (dataMessage.type === DataMessageTypeEnum.Todos) {
    const todosMessage = dataMessage as TodosMessage;
    const todos = todosMessage.todos;

    if (!todos?.some((todo) => todo.state === 'in_progress')) {
      return part;
    }

    return {
      ...part,
      data: {
        ...todosMessage,
        todos: todos.map((todo: TodoItem) =>
          todo.state === 'in_progress'
            ? { ...todo, state: 'cancelled' as const }
            : todo,
        ),
      },
    };
  }

  return part;
}
